import ProfileSettingsComponent from "../../components/Auth/ProfileSettingsComponent";
const UpdatePasswordPage = () => {
  return (
    <>
      <ProfileSettingsComponent />
    </>
  );
};
export default UpdatePasswordPage;
